(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("Header", [], factory);
	else if(typeof exports === 'object')
		exports["Header"] = factory();
	else
		root["Header"] = factory();
})(window, function() {
return 